/**
 * Macro reservada cujo texto é o lembrete que pré-preenche a caixa de ação do
 * ticket novo (item 42).
 *
 * O vínculo com a macro é pelo NOME — por isso o backend bloqueia excluí-la e
 * renomeá-la (MacroController@destroy / @update). O conteúdo continua editável
 * pelo administrador no cadastro de macros, que é o objetivo.
 *
 * ATENÇÃO: este nome precisa ser idêntico ao Macro::REMINDER_NAME da API
 * (alodesk-chat-api/app/Models/Macro.php). Se um lado mudar sem o outro, o
 * lembrete some sem erro nenhum.
 *
 * Para (re)criar a macro num ambiente:
 *   php artisan db:seed --class="\ReminderMacroSeeder"
 */
export const REMINDER_MACRO_NAME = 'Lembrete padrão';

export const normalizeMacroName = (name) =>
    String(name || '')
        .trim()
        .toLowerCase();

export const isReminderMacro = (macro) =>
    normalizeMacroName(macro?.name) === normalizeMacroName(REMINDER_MACRO_NAME);

/** O Quill representa "vazio" de várias formas; nenhuma deve bloquear o lembrete. */
export const isQuillEmpty = (html) => {
    const raw = String(html || '').trim();
    if (!raw) return true;
    return raw.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() === '';
};
